import { IOffer } from '@rbi-ctg/menu';
import { getUniqIdForOffer } from 'utils/offers';

/**
 * Creating this util function in order to more easily test that
 * Sanity is giving the client the offers in the right order
 */

const sortOffersToDisplay = (
  filteredOffers: IOffer[],
  standardOffers: IOffer[],
  promoCodeOffers: IOffer[]
) => {
  return filteredOffers.reduce((acc: Array<IOffer>, offer: IOffer) => {
    const uniqueId = getUniqIdForOffer({ id: offer._id, token: offer.tokenId });
    const foundStandardOffer = standardOffers.find(
      standardOffer =>
        getUniqIdForOffer({ id: standardOffer._id, token: standardOffer.tokenId }) === uniqueId
    );
    const foundPromoOffer = promoCodeOffers.find(
      promoCodeOffer =>
        getUniqIdForOffer({ id: promoCodeOffer._id, token: promoCodeOffer.tokenId }) === uniqueId
    );
    if (foundStandardOffer) {
      acc.push(foundStandardOffer);
    } else if (foundPromoOffer) {
      acc.push(foundPromoOffer);
    }
    return acc;
  }, []);
};
export default sortOffersToDisplay;
